<template>
  <div>
    <div class="head-card">
      <div class="head-card-top">
        <h4>{{ dsppartner.name }}</h4>
        <feather-icon
          v-if="closing"
          v-b-tooltip.hover.top="$t('Close')"
          icon="XIcon"
          size="18"
          class="toggle-close cursor-pointer"
          @click="$router.go(-1)"
        />
      </div>
      <hr>
      <div class="head-card-bottom">
        <b-button
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          variant="flat-primary"
          class="btn-icon"
          :to="{ name: 'dashboard-dsppartner-stats' }"
        >
          <feather-icon
            icon="BarChart2Icon"
            size="16"
          />
          {{ $t('Statistics') }}
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="flat-primary"
          class="btn-icon"
          :to="{ name: 'dashboard-dsppartner-logs' }"
        >
          <feather-icon
            icon="FileTextIcon"
            size="16"
          />
          {{ $t('logs') }}
        </b-button>
        <b-button
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          variant="flat-primary"
          class="btn-icon"
          :to="{ name: 'dashboard-dsppartner-edit' }"
        >
          <feather-icon
            icon="SettingsIcon"
            size="16"
          />
          {{ $t('Settings') }}
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="flat-primary"
          class="btn-icon"
          @click="showCopyCodeModal"
        >
          <feather-icon
            icon="CodeIcon"
            size="16"
          />
          Copy code here!
        </b-button>
        <copy-code-modal
          v-if="dsppartner._id"
          :partner-id="dsppartner._id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getUserData } from '@/auth/utils'
import Ripple from 'vue-ripple-directive'
import {
  BButton,
  VBTooltip,
} from 'bootstrap-vue'
import CopyCodeModal from './CopyCodeModal.vue'

export default {
  components: {
    BButton,
    CopyCodeModal,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    dsppartner: {
      type: Object,
      required: true,
    },
    closing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      authUserData: getUserData(),
    }
  },
  methods: {
    showCopyCodeModal() {
      this.$bvModal.show('copy-code-modal')
    },
  },
}
</script>
